module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-production-tile-09dbbf35c660552467ce8fb744f8476e.jpg";